<template>
    <v-app id='monthly'>

        
                <v-layout row class="mt-2">
                    <v-form ref="forms">
                        <v-flex lg12>

                            <div class="barcolor">

                                <span class="ml-lg-5" > Points to Improve* </span>

                            </div>
                            <div class="textareaBg mt-n1">

                                <v-layout>
                                    <v-flex lg8 class="ml-lg-12">

                                        <v-textarea
                                        placeholder="Write about the aspects that needs to be improved by the tutor for this month."
                                        class="textarea"
                                        auto-grow
                                        v-model="improve"
                                        :rules="inputRules"
                                        ></v-textarea>

                                    </v-flex>

                                </v-layout>

                            </div>

                        </v-flex>

                        <v-flex lg12 class="mt-lg-n0">

                            <div class="barcolor">

                                <span class="ml-lg-5" > Strengths* </span>

                            </div>
                            <div class="textareaBg mt-n1">

                                <v-layout>
                                    <v-flex lg8 class="ml-lg-12">

                                        <v-textarea
                                        placeholder="Write about the strong points about the tutor’s performance this month."
                                        class="textarea"
                                        auto-grow
                                        v-model="strength"
                                        :rules="inputRules"
                                        ></v-textarea>

                                    </v-flex>

                                </v-layout>

                            </div>

                        </v-flex>

                        <v-flex lg12 class="mt-lg-n0">

                            <div class="barcolor">

                                <span class="ml-lg-5" > Remarks </span>

                            </div>
                            <div class="textareaBg mt-n1">

                                <v-layout>
                                    <v-flex lg8 class="ml-lg-12">

                                        <v-textarea
                                        placeholder="You can write remarks about the tutor's performance in class handling here,important notes, suggestion, or justification especially if the change in the tutor's performance is unusual, be it positive or negative. This is optional."
                                        class="textarea"
                                        auto-grow
                                        v-model="remarks"
                                        ></v-textarea>

                                    </v-flex>

                                </v-layout>

                            </div>
                            <span v-if="emptymonth" class="red--text">  ERROR: No Selected Month   </span>
                        </v-flex>
                        <v-flex lg9 class="mt-lg-5 pb-5">
                                                
                                                <v-layout justify-end>
                                                    <v-btn color="rgb(0, 99, 158)" class="white--text" @click="SaveMonthly()"> SUBMIT </v-btn>
                                                </v-layout>

                        </v-flex>  
                    </v-form>
                </v-layout>
        
        
    </v-app>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
    name:'classHandlingMonthlyForm',
    props:['moReport','monthValue'],
    data: () => ({

            improve:'',
            remarks:'',
            strength:'',
            month:'',
            inputRules: [
                v => v.length >= 1 || "Item is Required"
            ],
            emptymonth : false,
            timestamp: new Date(),

    }),
    computed:{

        post(){
            return {
                actionTaken:'MonthlyData',
                event:"classHandling",
                tutor_id : this.$route.params.t_id,
                month: this.month,
                improve:this.improve,
                remarks:this.remarks,
                strength:this.strength,
                timestamp: this.timestamp.getFullYear()+"-"+(this.timestamp.getMonth() >= 9 ? (this.timestamp.getMonth()+1) : "0"+(this.timestamp.getMonth()+1))+"-"+(this.timestamp.getDate() > 9 ? this.timestamp.getDate() : "0"+this.timestamp.getDate())+" "+(this.timestamp.getHours() > 9 ? this.timestamp.getHours() : "0"+this.timestamp.getHours())+":"+(this.timestamp.getMinutes() > 9 ? this.timestamp.getMinutes() : "0"+this.timestamp.getMinutes())+":"+(this.timestamp.getSeconds() > 9 ? this.timestamp.getSeconds() : "0"+this.timestamp.getSeconds())
            }
        }

    },
    mounted(){

        this.moReport.$on('getMonthAssessment', this.getMonthAssessment) 

    },
    methods:{


        getMonthAssessment(){

            this.improve=this.monthValue.improve,
            this.remarks=this.monthValue.remarks,
            this.strength=this.monthValue.strength,
            this.month = this.monthValue.moNum

        },

        SaveMonthly(){
            
            this.emptymonth = false

            if(this.$refs.forms.validate()){
                
                if(this.month > 0){

                    axios.post('http://localhost/megatalking/performance/tutorperf.php',this.post).catch(error=>console.log('this is the error '+error))
                    this.$emit('updateMonth',this.post)

                } else {

                    this.emptymonth = true

                }
                    

            }

        }

    }
}
</script>
<style>
#monthly{
    background-color: rgb(246, 246, 246);
}
.barcolor{
    background-color: rgb(229, 229, 229);
    padding: 10px !important;
    font-weight: bold;
    width:100% !important;
}
.textareaBg{
    background-color: white !important;
}
.textarea{
    width:800px !important;
    font-size:10px;
}
</style>